import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { openLegalDocFromClick, withLangParam } from '../Legal/legalDocLinks';
import './CookieConsentBanner.css';

interface ICookieConsentBannerProps {
  onAcceptAll: () => void;
  onManageSettings: () => void;
  onAcceptNecessary: () => void;
}

const CookieConsentBanner: React.FC<ICookieConsentBannerProps> = ({
  onAcceptAll,
  onManageSettings,
  onAcceptNecessary,
}) => {
  const intl = useIntl();

  const handleClose = () => {
    onAcceptNecessary();
  };

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-main-content">
          <div className="cookie-text">
            <h3 className="cookie-title">
              🍪 {intl.formatMessage({ id: 'cookieConsent.title', defaultMessage: 'Our website uses cookies' })}
            </h3>
            <p className="cookie-description">
              {intl.formatMessage({
                id: 'cookieConsent.description',
                defaultMessage: 'Our website use cookies. By continuing, we assume your permission to deploy cookies as detailed in our'
              })} {' '}
              <a
                href={withLangParam('/terms-and-conditions?tab=privacy-policy', intl.locale)}
                className="privacy-link"
                onClick={(e) => openLegalDocFromClick(e, 'privacy-policy')}
              >
                {intl.formatMessage({ id: 'cookieConsent.privacyPolicy', defaultMessage: 'Privacy Policy' })}
              </a>
              .
            </p>
          </div>
        </div>
        <div className="cookie-actions">
          <button
            className="btn-manage"
            onClick={onManageSettings}
          >
            {intl.formatMessage({ id: 'cookieConsent.manage', defaultMessage: 'Manage' })}
          </button>
          <button
            className="btn-accept-all"
            onClick={onAcceptAll}
          >
            <span className="btn-accept-all-text">
              {intl.formatMessage({ id: 'cookieConsent.acceptAll', defaultMessage: 'Accept All' })}
            </span>
          </button>
        </div>
        <button
          className="btn-close"
          onClick={handleClose}
          aria-label="Close"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner; 